// ディスクレーマー表示ロジック（開発者向け仕様に準拠）
//
// 種類:
//   ① 共通ディスクレーマー        … _disclaimer-modal-1（.role あり / .about なし）
//   ② 疾患情報ディスクレーマー    … _disclaimer-modal-2（.about あり / .role なし）
//   ③ 共通＆疾患情報（一括）      … _disclaimer-modal-3（.about + .role 両方あり）
//
// ※ DOM の id は種類とズレているため、id ではなくマークアップ構造で判定する。
//
// 表示条件マトリクス:
//   一般ページ（/medical-affairs/ 以外）   common=✕            → ① 共通
//   一般ページ                              common=○            → 表示しない
//   疾患情報ページ（/medical-affairs/ 配下）common=✕ medical=✕  → ③ 一括（直接アクセス）
//   疾患情報ページ                          common=○ medical=✕  → ② 疾患情報（一般経由）
//   疾患情報ページ                          medical=○           → 表示しない
//   /system/ 配下                           ―                   → 対象外（判定しない）

const COOKIE_COMMON = 'disclaimer_common';
const COOKIE_MEDICAL = 'disclaimer_medical_affairs';
const COOKIE_MAX_AGE = 60 * 60 * 24 * 365; // 365日（1年）

const getCookie = (name) => {
  const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
  return match ? decodeURIComponent(match[1]) : null;
};

const setCookieAgreed = (name) => {
  let cookie = `${name}=true; max-age=${COOKIE_MAX_AGE}; path=/; SameSite=Lax`;
  // Secure は HTTPS のときのみ付与（localhost の http で Cookie が保存されないのを防ぐ）
  if (location.protocol === 'https:') cookie += '; Secure';
  document.cookie = cookie;
};

const isAgreed = (name) => getCookie(name) === 'true';

export const initDisclaimerModal = () => {
  const path = location.pathname;

  // /system/ 配下は判定対象外
  if (/(^|\/)system(\/|$)/.test(path)) return;

  const dialogs = document.querySelectorAll('.disclaimer-modal');
  if (!dialogs.length) return;

  // マークアップ構造で種類を判定
  let modalCommon = null;  // ① 共通
  let modalMedical = null; // ② 疾患情報
  let modalBoth = null;    // ③ 一括
  dialogs.forEach((dialog) => {
    const hasAbout = !!dialog.querySelector('.about');
    const hasRole = !!dialog.querySelector('.role');
    if (hasAbout && hasRole) modalBoth = dialog;
    else if (hasAbout) modalMedical = dialog;
    else if (hasRole) modalCommon = dialog;
  });

  const common = isAgreed(COOKIE_COMMON);
  const medical = isAgreed(COOKIE_MEDICAL);
  const onMedicalAffairs = /(^|\/)medical-affairs(\/|$)/.test(path);

  // 表示するモーダルを決定
  let target = null;
  if (onMedicalAffairs) {
    if (!medical) target = common ? modalMedical : modalBoth; // ② or ③
  } else {
    if (!common) target = modalCommon; // ①
  }
  if (!target) return;

  const lockScroll = () => {
    document.documentElement.style.overflow = 'hidden';
  };
  const unlockScroll = () => {
    document.documentElement.style.overflow = '';
  };
  const closeModal = () => {
    target.close();
    unlockScroll();
  };

  // ESC・バックドロップでは閉じさせない（必ず選択させる）
  target.addEventListener('cancel', (e) => e.preventDefault());

  // 医療従事者ボタン（① / ③ の同意）
  target.querySelectorAll('.role-btn:not(.-corporate)').forEach((btn) => {
    btn.addEventListener('click', () => {
      setCookieAgreed(COOKIE_COMMON);
      if (target === modalBoth) setCookieAgreed(COOKIE_MEDICAL); // ③ は common / medical 同時保存
      closeModal();
    });
  });

  // 疾患情報「同意して進む」（②）
  target.querySelectorAll('.consent-btn:not(.-cancel)').forEach((btn) => {
    btn.addEventListener('click', () => {
      setCookieAgreed(COOKIE_MEDICAL);
      closeModal();
    });
  });

  // 疾患情報「同意せず、元のページに戻る」（②）
  // 戻る履歴が無い（直接アクセス・別タブ）場合や前ページが外部サイトの場合に備え、
  // 履歴が無ければトップへフォールバックする
  target.querySelectorAll('.consent-btn.-cancel').forEach((btn) => {
    btn.addEventListener('click', () => {
      if (history.length > 1) {
        history.back();
      } else {
        location.href = '/';
      }
    });
  });

  // 「医療従事者以外の方はこちら（コーポレートサイト）」は <a> のまま遷移させる（JS は介入しない）

  target.showModal();
  lockScroll();
};
